export default class LanguageSelectorHelper {
  static openLink(culture, event) {
    event.stopImmediatePropagation();
    var redirectUrlElement = document.querySelector(`[data-sf-role="${culture}"]`);

    if (redirectUrlElement) {
      var url = redirectUrlElement.value;
      window.location.href = url;
    }
  }
}

